import "./features.css";
import { Controller as BaseController } from "@hotwired/stimulus";

export class Controller extends BaseController {
  static targets = ["value"];

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.animateValues();
            this.observer.disconnect();
          }
        });
      },
      { threshold: 0.8 }
    );

    this.observer.observe(this.element);
  }

  animateValues() {
    const duration = 1600;

    this.valueTargets.forEach((el) => {
      const startTime = performance.now();
      const end = parseFloat(el.dataset.value);

      const update = (now) => {
        const progress = Math.min((now - startTime) / duration, 1);
        const current = Math.floor(progress * end);
        el.textContent = current;

        if (progress < 1) requestAnimationFrame(update);
      };

      requestAnimationFrame(update);
    });
  }
}
